import { useState, useEffect, useRef } from 'react';
import AX from 'axios';
import axios from '../_actions/axiosInstance';

const useAxios = (apiObj, refresh) => {
  const [response, setResponse] = useState({ data: [] });
  const [pagination, satPagination] = useState({
    page: 1,
    pageSize: 5,
    total: 1,
    hasNext: false,
    hasPrevious: false
  });
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);
  const source = useRef(AX.CancelToken.source());

  const runAxios = async req => {
    if (source) {
      source.current.cancel('rerun');
      source.current = AX.CancelToken.source();
    }
    try {
      setLoading(true);
      const res = await axios.request(req, { cancelToken: source.current.token });
      const size = parseInt(new URLSearchParams(req).get('size'), 10);
      setResponse(res.data);
      satPagination({
        page: res.data.current_page,
        pageSize: size,
        total: Math.ceil(res.data.total / size),
        hasNext: res.data.has_next,
        hasPrevious: res.data.has_previous
      });
      setLoading(false);
    } catch (e) {
      if (e.message === 'destroy') return;
      const errorObj = { ...e };
      if (errorObj?.response?.status) {
        setError(errorObj.response.status);
      } else {
        setError('test');
      }
      setLoading(e?.message === 'rerun');
    }
  };

  useEffect(() => {
    if (apiObj) {
      runAxios(apiObj);
    }
  }, [apiObj, refresh]);

  return { response, pagination, loading, error, source };
};

export default useAxios;
